(function(){
'use strict';
if(window.__fzLightDropdowns)return;window.__fzLightDropdowns=true;
var active=null,timer=null;
function ok(s){if(s.dataset.fzLight||s.multiple||s.size>1||s.options.length<2||s.options.length>40)return false;
if(!s.getClientRects().length||getComputedStyle(s).display==='none'||getComputedStyle(s).visibility==='hidden'||getComputedStyle(s).opacity==='0'||s.getAttribute('aria-hidden')==='true')return false;
var k=((s.name||'')+' '+(s.id||'')).toLowerCase();
return !/country|province|language|currency|sort_by|filter\\.|region|timezone/.test(k)&&!s.closest('footer,.localization-form');}
function value(s){return s.selectedIndex<0?'':s.options[s.selectedIndex].textContent.trim();}
function update(s){if(s.__fzButton){var label=s.__fzButton.querySelector('span'),v=value(s);if(label.textContent!==v)label.textContent=v;s.__fzButton.disabled=s.disabled;}}
function close(){if(!active)return;active.button.setAttribute('aria-expanded','false');active.menu.remove();active=null;}
function open(s){if(active&&active.select===s){close();return;}close();update(s);
var b=s.__fzButton,r=b.getBoundingClientRect(),p=document.createElement('div');p.className='fz-light-menu';p.setAttribute('role','listbox');
var above=window.innerHeight-r.bottom<180&&r.top>180;
p.style.left=Math.max(8,Math.min(r.left,window.innerWidth-r.width-8))+'px';
p.style.width=Math.min(r.width,window.innerWidth-16)+'px';
p.style.maxHeight=Math.min(300,Math.max(100,above?r.top-14:window.innerHeight-r.bottom-12))+'px';
p.style.top=(above?'auto':r.bottom+4+'px');if(above)p.style.bottom=(window.innerHeight-r.top+4)+'px';
Array.prototype.forEach.call(s.options,function(opt,i){
var item=document.createElement('button');item.type='button';item.className='fz-light-option';
item.setAttribute('role','option');item.setAttribute('aria-selected',String(s.selectedIndex===i));
item.textContent=opt.textContent.trim();item.disabled=opt.disabled;
if(i===s.selectedIndex)item.classList.add('is-selected');
item.addEventListener('click',function(){s.selectedIndex=i;
s.dispatchEvent(new Event('input',{bubbles:true}));s.dispatchEvent(new Event('change',{bubbles:true}));
update(s);close();b.focus({preventScroll:true});});
p.appendChild(item);
});
document.body.appendChild(p);active={menu:p,button:b,select:s};b.setAttribute('aria-expanded','true');
var selected=p.querySelector('.is-selected');if(selected)p.scrollTop=Math.max(0,selected.offsetTop-48);
}
function enhance(s){if(!ok(s))return;
var b=document.createElement('button');b.type='button';b.className='fz-light-trigger';
b.setAttribute('aria-haspopup','listbox');b.setAttribute('aria-expanded','false');
b.setAttribute('aria-label',s.getAttribute('aria-label')||(s.labels&&s.labels[0]&&s.labels[0].textContent.trim())||'Choose an option');
b.appendChild(document.createElement('span'));
var arrow=document.createElementNS('http://www.w3.org/2000/svg','svg');
arrow.setAttribute('class','fz-light-chevron');
arrow.setAttribute('viewBox','0 0 24 24');
arrow.setAttribute('aria-hidden','true');
arrow.setAttribute('focusable','false');
var arrowPath=document.createElementNS('http://www.w3.org/2000/svg','path');
arrowPath.setAttribute('d','M5 9l7 7 7-7');
arrow.appendChild(arrowPath);
b.appendChild(arrow);
s.insertAdjacentElement('afterend',b);
s.classList.add('fz-light-native');s.dataset.fzLight='1';s.setAttribute('tabindex','-1');s.setAttribute('aria-hidden','true');s.__fzButton=b;
b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();open(s);});update(s);
}
function scan(){document.querySelectorAll('#MainContent select,.appstle_sub_widget select,.fzpc__sel,.fzp__frequency').forEach(function(s){
if(s.dataset.fzLight){update(s);if(!s.__fzButton||!s.__fzButton.isConnected){s.removeAttribute('data-fz-light');enhance(s);}}else enhance(s);
});if(active&&!active.select.isConnected)close();}
function schedule(){clearTimeout(timer);timer=setTimeout(scan,150);}
document.addEventListener('change',function(e){if(e.target.tagName==='SELECT')update(e.target);},true);
document.addEventListener('input',function(e){if(e.target.tagName==='SELECT')update(e.target);},true);
document.addEventListener('pointerdown',function(e){if(active&&!active.button.contains(e.target)&&!active.menu.contains(e.target))close();},true);
document.addEventListener('keydown',function(e){if(!active)return;
if(e.key==='Escape'){e.preventDefault();var b=active.button;close();b.focus({preventScroll:true});}
else if(e.key==='ArrowDown'||e.key==='ArrowUp'){var opts=Array.from(active.menu.querySelectorAll('button:not(:disabled)'));
var i=opts.indexOf(document.activeElement);if(i<0)i=opts.indexOf(active.menu.querySelector('.is-selected'));
if(opts.length){e.preventDefault();opts[(i+(e.key==='ArrowDown'?1:-1)+opts.length)%opts.length].focus();}}
else if(e.key==='Enter'&&document.activeElement===active.button){e.preventDefault();var sel=active.menu.querySelector('.is-selected');if(sel)sel.click();}
});
window.addEventListener('resize',function(){if(active)close();});
document.addEventListener('scroll',function(e){if(active&&!active.menu.contains(e.target))close();},true);
new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true});
document.addEventListener('shopify:section:load',schedule);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
})();